import { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TourId } from './shared-types';
import GlobalAppContext from '../../components/custom-controls/local-selector/global-app-context';

export const useTourRegistry = () => {
	const location = useLocation();

	const [buttonLabel, setButtonLabel] = useState<string>('');
	const [routeTour, setRouteTour] = useState<TourId | undefined>();
	const { isEditView } = useContext(GlobalAppContext);

	useEffect(() => {
		const getTourRoute = () => {
			const routeConfigs: { keyword: string; tour: TourId; label: string; isEditView: boolean }[] =
				[
					{
						keyword: 'flow',
						tour: 'editFlow',
						label: 'Edit Flow Tutorial',
						isEditView: true,
					},
				];

			const match = routeConfigs.find(config => {
				if (location.pathname.includes(config.keyword) && isEditView === config.isEditView) {
					return config;
				}
				return undefined;
			});

			if (match) {
				setRouteTour(match.tour);
				setButtonLabel(match.label);
			} else {
				setRouteTour(undefined);
				setButtonLabel('');
			}
		};
		getTourRoute();
		return () => {
			setRouteTour(undefined);
			setButtonLabel('');
		};
	}, [location.pathname, isEditView]);

	return { routeTour, buttonLabel };
};
